import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ijp-sga-dashboard',
  templateUrl: './ijp-sga-dashboard.component.html',
  styleUrls: ['./ijp-sga-dashboard.component.scss']
})
export class IJPSGADashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
